// LocationHandling/locationKey.ts (or inline)
export const locationKey = (loc?: {
  city?: string;
  country?: string;
  countryCode?: string;
}) => {
  if (!loc) return '∅';

  const city = (loc.city || '').toLowerCase();
  const cc = (loc.countryCode || '').toUpperCase();
  const country = (loc.country || '').toLowerCase();

  const countrySig = cc || country;

  return `${city}|${countrySig}`;
};
  